import { z } from 'zod';

const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const billingSchema = z
	.object({
		name: z.string().trim().min(2, 'Billing name required'),

		phone: z
			.string()
			.trim()
			.min(1, 'Phone number is required')
			.regex(/^[6-9]\d{9}$/, 'Enter valid 10 digit phone number'),

		address: z.string().trim().min(5, 'Street address required'),

		country: z.string().trim().min(1, 'Country is required'),

		state: z.string().trim().min(1, 'State is required'),

		pincode: z
			.string()
			.trim()
			.regex(/^\d{6}$/, 'Enter valid 6 digit pincode'),

		city: z.string().trim().min(1, 'City is required'),

		gst: z.boolean(),

		gstin: z.string().optional(),

		paymentType: z.enum(['recurring', 'one-time']),

		paymentMethod: z.enum(['card', 'upi']),
	})
	.superRefine((data, ctx) => {
		if (data.gst) {
			const gstin = data.gstin?.trim()?.toUpperCase();

			if (!gstin) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['gstin'],
					message: 'GSTIN is required',
				});

				return;
			}

			if (!gstRegex.test(gstin)) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['gstin'],
					message: 'Enter valid GSTIN number',
				});
			}
		}
	});
